module.exports = __webpack_public_path__ + "img/98.d285e05f.jpg";